var _defs, _path, _path2, _ellipse, _path3, _text, _polygon, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.45 85.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#fff;}.cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{stroke-width:6px;}.cls-3{font-size:30px;font-family:LucidaCalligraphy-Italic, Lucida Calligraphy;font-style:italic;}.cls-4{font-size:39.66px;fill:#5f3916;font-family:Rockwell-ExtraBold, Rockwell Extra Bold;font-weight:800;}.cls-5{letter-spacing:-0.02em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1708.5,51.5",
    transform: "translate(-545.18 -322)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M587.74,325H793.66c8.3,0,13.6,7.78,9.62,14.16C791.61,357.88,811.35,364,829.89,358c7.15-2.3,14.74,2.32,14.74,9v26c0,5.3-4.9,9.59-11,9.59H599.28c-8.33,0-13.57-7.81-9.58-14.21,7.46-12,8.35-25.66-26.93-14.63-7.11,2.22-14.59-2.43-14.59-9v-5.11C548.18,340.51,565.89,325,587.74,325Z",
    transform: "translate(-545.18 -322)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 32.64,
    cy: 62.9,
    rx: 19.96,
    ry: 17.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.34,48H289.86a7.64,7.64,0,0,1,7.64,7.64v17a7.64,7.64,0,0,1-7.64,7.64H145.46a.77.77,0,0,1-.77-.77V55.64A7.64,7.64,0,0,1,152.34,48Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(151.13 75.98)"
  }, "RESORT")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.87 52 36.27 63.09 14.87 74.19 14.87 52"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(63.03 47.29)"
  }, "BE", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 63.61,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.95,
    y: 0
  }, "CH"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4504aca08b3dadc9f6ee3136f47c24bb.svg";
export { ForwardRef as ReactComponent };